import api from '../lib/axios';

export const getUsers = () => api.get('/users');
export const getUserDirectory = () => api.get('/users/directory');
export const createUser = (data) => api.post('/users', data);
export const updateUser = (id, data) => api.patch(`/users/${id}`, data);
export const deleteUser = (id) => api.delete(`/users/${id}`);
export const updatePushSubscription = (subscription) =>
  api.post('/users/push-subscription', { subscription });
